<div class="iframe-container" *ngIf="seccionActive">
    <iframe
      id="traccarIframe"
      [src]="urlTraccar"
      frameborder="0"
      allow="same-origin"
      (load)="onIframeLoad($event)"
    ></iframe>
  </div>